// "Show more" for the Google reviews footer (theme spec 2026-09-28 §2.2). First tap on a phone reveals the
// footer's hidden cards; later taps append the pool 24 at a time; when it runs out, the "See all on Google"
// link replaces the button. One delegated listener; closest() so a tap on any child still counts.
(function () {
  var BATCH = 24;
  var pool = null;       // array of card elements once fetched
  var loading = false;

  function finish(root) {
    var more = root.querySelector('[data-google-reviews-more]');
    var all = root.querySelector('[data-google-reviews-all]');
    var wasFocused = more && document.activeElement === more;
    if (all) all.hidden = false;
    if (wasFocused && all) all.focus();
    if (more) more.hidden = true;
  }

  // CSS columns can't be appended to without reflowing every card, and a grid per batch leaves the ragged
  // bottom of each batch as holes. So on the first append the grid becomes real column divs, each card kept
  // in the column CSS had put it in, and new cards go to the shortest column.
  function colCount(grid) {
    return Math.max(1, Math.min(4, Math.floor((grid.clientWidth + 16) / (260 + 16))));
  }

  function fill(grid, cards) {
    var cols = [];
    grid.innerHTML = '';
    for (var i = 0; i < colCount(grid); i++) {
      cols.push(grid.appendChild(document.createElement('div')));
      cols[i].className = 'google-reviews__col';
    }
    cards.forEach(function (card) { shortest(cols).appendChild(card); });
  }

  function shortest(cols) {
    return cols.reduce(function (a, b) { return b.offsetHeight < a.offsetHeight ? b : a; });
  }

  function columnize(grid) {
    if (grid.classList.contains('google-reviews__grid--cols')) return;
    var cards = Array.prototype.slice.call(grid.children);
    var lefts = cards.map(function (c) { return Math.round(c.getBoundingClientRect().left); });
    var xs = lefts.filter(function (x, i) { return lefts.indexOf(x) === i; }).sort(function (a, b) { return a - b; });
    grid.classList.add('google-reviews__grid--cols');
    grid.innerHTML = '';
    var cols = xs.map(function () {
      var col = grid.appendChild(document.createElement('div'));
      col.className = 'google-reviews__col';
      return col;
    });
    cards.forEach(function (c, i) { cols[xs.indexOf(lefts[i])].appendChild(c); });
    var width = grid.clientWidth;
    window.addEventListener('resize', function () {     // rotate / resize: redistribute, placement can't survive it
      if (grid.clientWidth === width) return;
      width = grid.clientWidth;
      if (grid.children.length === colCount(grid)) return;
      fill(grid, Array.prototype.slice.call(grid.querySelectorAll('.google-reviews__card')));
    });
  }

  function appendBatch(root) {
    var grid = root.querySelector('[data-google-reviews-grid]');
    if (!grid) return;
    columnize(grid);
    var cols = Array.prototype.slice.call(grid.children);
    pool.splice(0, BATCH).forEach(function (card) { shortest(cols).appendChild(card); });
    if (!pool.length) finish(root);
  }

  // Review photos open in a <dialog> on the page; before this deferred script runs, the link opens the image.
  var box = null;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-google-review-photo]');
    if (!a || !window.HTMLDialogElement) return;
    e.preventDefault();
    if (!box) {
      box = document.createElement('dialog');
      box.className = 'google-reviews__lightbox';
      box.innerHTML = '<button type="button">&times;</button><img alt="">';
      box.addEventListener('click', function () { box.close(); }); // backdrop, photo or ×
      document.body.appendChild(box);
    }
    var root = a.closest('[data-google-reviews]');
    var close = box.querySelector('button');
    close.setAttribute('aria-label', (root && root.getAttribute('data-close-label')) || 'Close');
    var img = box.querySelector('img');
    img.removeAttribute('src');                                     // don't flash the previous photo
    img.src = a.href;
    img.alt = a.querySelector('img').alt;
    box.showModal();
    close.focus();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-google-reviews-more]');
    if (!btn) return;
    var root = btn.closest('[data-google-reviews]');
    if (!root) return;
    var hadHidden = !root.classList.contains('google-reviews--expanded') &&
      window.matchMedia('(max-width: 798px)').matches &&
      root.querySelector('.google-reviews__card--extra');
    root.classList.add('google-reviews--expanded');
    if (hadHidden) return;                       // this tap only revealed the footer's own cards
    if (pool) { appendBatch(root); return; }
    if (loading) return;
    loading = true;
    btn.setAttribute('aria-busy', 'true');
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_url + root.getAttribute('data-pool-path'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var holder = tpl.content.querySelector('[data-google-reviews-pool]');
        pool = holder ? Array.prototype.slice.call(holder.children) : [];
        if (pool.length) appendBatch(root); else finish(root);
      })
      .catch(function () { finish(root); })
      .then(function () { loading = false; btn.removeAttribute('aria-busy'); });
  });
})();
